import { FormControl, TextField } from '@mui/material';
import React from 'react';
import DefaultButton from '../../../components/FormControl/DefaultButton';
import ErrorButton from '../../../components/FormControl/ErrorButton';
import FormDialog from '../../../components/FormControl/FormDialog';
import SearchEntity from '../../../components/SelectSearch/SearchEntity';
import Component from "../../../model/Component";
import { ServiceApi } from '../../../service/ServiceApiWithLoading';
import { InputComponentPrice } from '../../../components/InputComponentPrice';

export interface TechAssisComponentFormDialogData {
    amount: number | null;
    sale_value: number | null;
    purchase_value: number | null;
    component_id: number | null;
}

export interface TechAssisComponentFormDialogState {

}

export interface TechAssisComponentFormDialogProps {
    open: boolean;
    onSubmit: (data: TechAssisComponentFormDialogData) => any;
    onCancel: () => any;
    selectedComponentsIds: number[];
}

export default class TechAssisComponentFormDialog extends React.Component<TechAssisComponentFormDialogProps, TechAssisComponentFormDialogState> {

    private apiComponent: ServiceApi<Component>;

    constructor(props: TechAssisComponentFormDialogProps) {
        super(props);
        this.state = {

        };
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.apiComponent = new ServiceApi<Component>('component');
    }

    onSubmitHandler(data: TechAssisComponentFormDialogData) {
        const { onSubmit } = this.props;
        onSubmit(data);
    }

    render() {
        const { open, onCancel, selectedComponentsIds } = this.props;
        return (
            <FormDialog<TechAssisComponentFormDialogData>
                show={open}
                title={'Selecione o componente e quantidade'}
                dismiss={() => null}
                onSubmit={(values, errors) => {
                    const { amount, sale_value, purchase_value, component_id } = values;
                    this.onSubmitHandler({ amount, sale_value, purchase_value, component_id });
                }}
                initialValues={{ amount: null, sale_value: null, purchase_value: null, component_id: null }}
                enableReinitialize={true}
                maxWidth='sm'
                fullWidth
            >
                {({ values, errors, handleChange, setFieldValue, isSubmitting, dirty }) => (
                    <>
                        <FormControl fullWidth variant="outlined" margin='dense'>
                            <SearchEntity<Component, 'id', 'name'>
                                name="component_id"
                                entity="component"
                                valueField='id'
                                labelField="name"
                                label="Componente"
                                value={values.component_id || null}
                                onChangeHandle={async (_, v) => {
                                    await setFieldValue('component_id', v || null);
                                    const component = v ? await this.apiComponent.getById(v) : null;
                                    await setFieldValue('sale_value', component ? component.sale_value : null);
                                    await setFieldValue('purchase_value', component ? component.purchase_value : null);
                                }}
                                isClearable
                                customLabel={(item: Component | null) => {
                                    if (!item) return '';
                                    return item.code ? `${item.code} - ${item.name}` : item.name;
                                }}
                                likeColumns={['code', 'name']}
                                extraWhere={selectedComponentsIds.length > 0 ? [['id', 'notIn', selectedComponentsIds]] : undefined}
                                required
                            />
                            <TextField
                                name="amount"
                                label={'Quantidade'}
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                inputProps={{ maxLength: 6 }}
                                value={values.amount || ''}
                                required
                                onChange={e => {
                                    const re = /^[0-9\b]+$/;
                                    let val = e.target.value;
                                    if (val === '' || re.test(val)) {
                                        setFieldValue('amount', val ? parseInt(val) : null);
                                    }
                                }}                                
                            />
                            <TextField
                                name="sale_value"
                                label={'Valor de venda'}
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                disabled
                                value={values.sale_value || ''}
                                id="formatted-numberformat-sale_value"
                                InputProps={{
                                    inputComponent: InputComponentPrice as any
                                }}
                            />
                            <TextField
                                name="purchase_value"
                                label={'Valor de compra'}
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                disabled
                                value={values.purchase_value || ''}
                                id="formatted-numberformat-purchase_value"
                                InputProps={{
                                    inputComponent: InputComponentPrice as any
                                }}
                            />
                        </FormControl>
                        <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <DefaultButton
                                size='small'
                                type='submit'
                                variant="contained"
                                disabled={isSubmitting}>
                                OK
                            </DefaultButton>
                            <ErrorButton
                                size='small'
                                variant="contained"
                                disabled={isSubmitting}
                                onClick={() => onCancel()}
                                style={{ marginLeft: 10 }}>
                                Cancelar
                            </ErrorButton>
                        </FormControl>
                    </>
                )}
            </FormDialog>
        );
    }
}